import { createContext } from 'react';
import { createContextualCan } from '@casl/react';

export const PermissionsContext = createContext();
export const PermissionsContextProvider = PermissionsContext.Provider;
export const Can = createContextualCan(PermissionsContext.Consumer);
